export const DEFAULT_LOCALE: Intl.LocalesArgument = 'en-US';
export const DEFAULT_LOCALE_OPTIONS = (
  precision: number
): Intl.NumberFormatOptions => ({
  minimumFractionDigits: 0,
  maximumFractionDigits: precision,
});
